import { useCachedData } from './useCachedData';
import { supabase } from '../utils/supabase';
import { useToast } from '../context/ToastContext';
import type { FilterItem } from '../types/filterItem';
import { CACHE_KEYS } from '../constants/cacheKeys';

interface Note {
  id: string;
  title: string;
  custom_tags: string[];
  date_tags: string[];
  created_at: string;
}

const transformToFilterItem = (note: Note): FilterItem => ({
  id: note.id,
  title: note.title || 'Untitled Note',
  type: 'note',
  custom_tags: note.custom_tags || [],
  date_tags: note.date_tags || [],
  created_at: note.created_at
});

export const useNotes = () => {
  const { showToast } = useToast();

  const { data: notes, error } = useCachedData<FilterItem[]>(
    async () => {
      const { data, error } = await supabase
        .from('notes')
        .select('id, title, custom_tags, date_tags, created_at')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return (data || []).map(transformToFilterItem);
    },
    {
      cacheKey: CACHE_KEYS.NOTES,
      onError: (error) => {
        console.error('Failed to load notes:', error);
        showToast('Failed to load notes', 'error');
      }
    }
  );

  return { notes, error };
}; 